import { useState } from "react";
import CartDrawer from "./CartDrawer";
import CartIcon from "./CartIcon";
const Cart = () => {
  const [showCart, setShowCart] = useState(false);
  return (
    <>
      <CartIcon onClick={() => setShowCart(true)} />
      {showCart && <CartDrawer onClose={() => setShowCart(false)} />}{" "}
    </>
  );
};

export default Cart;
